import React from "react";
import { Grid, Skeleton, Typography } from "@mui/material";
import { useTranslation } from "react-i18next";
import { useTheme } from "@mui/material/styles";
import { OutgoingEnvelop } from "../../../../assets/icons";
import { MailInboxSummaryDTO } from "../../../../models/mail-inbox-summary/mail-inbox-summary-dto";
import { useAppSelector } from "../../../../custom-hooks/redux/redux";
import { AUTHORIZATIONS } from "../../../../utils/constants/authorization-constants";

const PendingOutgoingMailLink = ({
  customSummary,
  loading,
}: {
  customSummary: MailInboxSummaryDTO;
  loading: boolean;
}) => {
  const { t } = useTranslation();
  const tRP = "components.custom_widget_links.manage_mail";
  const theme = useTheme();

  const { currentUserAuthorizations } = useAppSelector((state) => state.currentUserReducer);

  const hasAccessToOutgoing =
    (currentUserAuthorizations?.allowedDomains.includes(AUTHORIZATIONS.MailInboxAccess.CanUploadOutgoing) ||
      currentUserAuthorizations?.allowedDomains.includes(AUTHORIZATIONS.MailInboxAccess.CanClassifyOutgoing) ||
      currentUserAuthorizations?.allowedDomains.includes(AUTHORIZATIONS.MailInboxAccess.CanReadOutgoing) ||
      currentUserAuthorizations?.allowedDomains.includes(AUTHORIZATIONS.MailInboxAccess.CanProcessOutgoing)) ??
    false;

  return (
    <Grid
      style={{
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        gap: "5px",
        width: "100%",
      }}
    >
      {loading && (
        <Skeleton
          variant="rounded"
          width={"70%"}
          style={{ marginBottom: "2px" }}
        />
      )}
      {hasAccessToOutgoing && !!customSummary?.pendingOutgoing && customSummary.pendingOutgoing > 0 && (
        <>
          <Grid
            style={{
              display: "flex",
              color: theme.palette.primary.main,
              justifyContent: "left",
              alignItems: "end",
              gap: "5px",
              width: "150px",
              margin: "3px 0px",
            }}
          >
            <OutgoingEnvelop style={{ width: "25px", height: "25px" }} />
            <Typography style={{ fontSize: "16px", lineHeight: "14px" }}>{customSummary.pendingOutgoing}</Typography>
            <Typography style={{ fontSize: "16px", lineHeight: "14px", color: theme.palette.text.primary }}>
              {`${t(`${tRP}.outgoing`)}`}
            </Typography>
          </Grid>
        </>
      )}
    </Grid>
  );
};
export default PendingOutgoingMailLink;
